import React from 'react'
import { useTranslation } from 'react-i18next'

import styles from '../LuckyDraw.modal.module.scss'

interface OverviewTabProps {
  minDeposit: number
  maxReward: number
}

export const OverviewTab: React.FC<OverviewTabProps> = ({ minDeposit, maxReward }) => {
  const { t } = useTranslation()

  const conditionDefs: ReadonlyArray<{
    key: string
    values?: { minDeposit?: number; maxReward?: number }
  }> = [
    { key: 'luckyDraw.overviewConditions.condition1', values: { minDeposit } },
    { key: 'luckyDraw.overviewConditions.condition2' },
    { key: 'luckyDraw.overviewConditions.condition3', values: { maxReward } },
    { key: 'luckyDraw.overviewConditions.condition4' },
    { key: 'luckyDraw.overviewConditions.condition5' },
  ] as const

  const conditions = conditionDefs
    .map(({ key, values }) => ({ key, text: t(key, values) }))
    .filter(({ text }) => Boolean(text))

  return (
    <div className={styles.tabWrapper}>
      <ul className={styles.conditions}>
        {conditions.map(({ key, text }, idx) => (
          <li key={key ?? idx}>{text}</li>
        ))}
      </ul>
    </div>
  )
}
